import { InputMaskTokenDictionary } from './../../../../../hooks/useInputMask/model';

export const DATE_INPUT_MASK = '##.##.####';

export const dateInputMaskTokens: InputMaskTokenDictionary = {
  '#': {
    pattern: /\d/,
  },
};
